


































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';

import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import hasPermission from '@/libs/permission';

import { Bank } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import ReportTable from './ReRequestTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchIcon,
    ExportIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
    FormInput,
  },
  methods: {
    hasPermission,
  },
})
export default class Report extends Vue {
  searchOpen = false;
  selectedCount = 0;

  dateRequest: DateRange = {
    startDate: null,
    endDate: null,
  }

  dateDisburse: DateRange = {
    startDate: null,
    endDate: null,
  }

  referenceIds: SelectItem[] = [];
  names: SelectItem[] = [];
  emails: SelectItem[] = [];
  banks: { label: string; value: string }[] = []
  bankAccountNames: SelectItem[] = [];
  bankAccountNumbers: SelectItem[] = [];
  amounts: SelectItem[] = [];
  disbursementDescriptions: SelectItem[] = [];
  disbursementNote = '';

  loadingSummaryTraffic = false;
  loadingSummaryAmount = false;
  loadingExport = false;
  loadingBank = false;

  bankOptions: { label: string; value: string }[] = []

  summaryTraffic = 0;
  summaryAmount = 0;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: ReportTable;
  }

  format!: (val: string) => string;
  hasPermission!: (val: string) => boolean;

  statusOptions = [
    {
      label: 'On Process',
      value: 'onprocess',
    },
    {
      label: 'Success',
      value: 'success',
    },
    {
      label: 'Failed',
      value: 'failed',
    },
  ]

  mounted() {
    this.parseParams();
    this.getSummary('request');
    this.getSummary('amount');
    this.getBanks();
  }

  @Watch('$route')
  onRouteChange() {
    this.getSummary('request');
    this.getSummary('amount');
    this.parseParams();
  }

  @Watch('summaryTrafficOption')
  onSummaryTrafficOptionChange() {
    this.getSummary('request');
  }

  @Watch('summaryAmountOption')
  onSummaryAmountOptionChange() {
    this.getSummary('amount');
  }

  onRefresh() {
    this.parseParams();
    this.getSummary('request');
    this.getSummary('amount');
  }

  async getBanks() {
    try {
      this.loadingBank = true;
      const { data } = await api.get<Bank[]>('/bank');
      const banks = data[0];
      this.bankOptions = Object.entries(banks).map((e) => ({ label: e[1], value: e[0] }));
      this.loadingBank = false;
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to load bank list');
    }
  }

  async getSummary(type: 'amount' | 'request') {
    try {
      if (type === 'amount') {
        this.loadingSummaryAmount = true;
      } else {
        this.loadingSummaryTraffic = true;
      }

      const dateRequest = {
        startDate: this.dateRequest.startDate === null ? undefined
          : dayjs(this.dateRequest.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.dateRequest.endDate === null ? undefined
          : dayjs(this.dateRequest.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const dateDisburse = {
        startDate: this.dateDisburse.startDate === null ? undefined
          : dayjs(this.dateDisburse.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.dateDisburse.endDate === null ? undefined
          : dayjs(this.dateDisburse.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const referenceIds = this.referenceIds.length === 0 ? undefined
        : this.referenceIds.map((e) => e.value);
      const names = this.names.length === 0 ? undefined
        : this.names.map((e) => e.value);
      const emails = this.emails.length === 0 ? undefined
        : this.emails.map((e) => e.value);
      const banks = this.banks.length === 0 ? undefined
        : this.banks.map((e) => e.value);
      const bankAccountNames = this.bankAccountNames.length === 0 ? undefined
        : this.bankAccountNames.map((e) => e.value);
      const bankAccountNumbers = this.bankAccountNumbers.length === 0 ? undefined
        : this.bankAccountNumbers.map((e) => e.value);
      const amounts = this.amounts.length === 0 ? undefined
        : this.amounts.map((e) => e.value);
      const disbursementDescriptions = this.disbursementDescriptions.length === 0 ? undefined
        : this.disbursementDescriptions.map((e) => e.value);
      const disbursementNote = this.disbursementNote != null ? this.disbursementNote : undefined;

      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.get(`/disbursement/summary/${type}`, {
        params: {
          request_start_date: dateRequest.startDate,
          request_end_date: dateRequest.endDate,
          disburse_start_date: dateDisburse.startDate,
          disburse_end_date: dateDisburse.endDate,
          reference_id: referenceIds,
          receiver_name: names,
          receiver_email: emails,
          bank_destination: banks,
          bank_account_name: bankAccountNames,
          bank_account_number: bankAccountNumbers,
          amount: amounts,
          description: disbursementDescriptions,
          note: disbursementNote,
          status: ['failed'],
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */

      if (type === 'amount') {
        this.loadingSummaryAmount = false;
        this.summaryAmount = Number(data.total_request_amount);
      } else {
        this.loadingSummaryTraffic = false;
        this.summaryTraffic = data.total_request;
      }
    } catch (err) {
      console.error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getDisbursment(isExport = false, page: number) {
    const params = {
      dateRequest: this.dateRequest,
      dateDisburse: this.dateDisburse,
      referenceIds: this.referenceIds,
      names: this.names,
      emails: this.emails,
      banks: this.banks,
      bankAccountNames: this.bankAccountNames,
      bankAccountNumbers: this.bankAccountNumbers,
      amounts: this.amounts,
      disbursementDescriptions: this.disbursementDescriptions,
      note: this.disbursementNote,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getDisbursment(params, false, page);
    }
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.dr === 'string') {
      const dates = params.dr.split(',');
      this.dateRequest = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    }

    if (typeof params.dd === 'string') {
      const dates = params.dd.split(',');
      this.dateDisburse = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    }
    if (typeof params.ba === 'string') {
      const banks = params.ba.split(',');
      const banksArray = banks.map((e) => {
        const val = e.split('_');
        return {
          label: val[0],
          value: val[1],
        };
      });

      this.banks = banksArray;
    } else {
      this.banks = [];
    }

    if (typeof params.re === 'string') {
      const referenceIds = params.re.split(',');
      this.referenceIds = referenceIds.map((e) => ({ key: '', value: e }));
    } else {
      this.referenceIds = [];
    }

    if (typeof params.na === 'string') {
      const names = params.na.split(',');
      this.names = names.map((e) => ({ key: '', value: e }));
    } else {
      this.names = [];
    }

    if (typeof params.em === 'string') {
      const emails = params.em.split(',');
      this.emails = emails.map((e) => ({ key: '', value: e }));
    } else {
      this.emails = [];
    }

    if (typeof params.bn === 'string') {
      const bankAccountNames = params.bn.split(',');
      this.bankAccountNames = bankAccountNames.map((e) => ({ key: '', value: e }));
    } else {
      this.bankAccountNames = [];
    }

    if (typeof params.bu === 'string') {
      const bankAccountNumbers = params.bu.split(',');
      this.bankAccountNumbers = bankAccountNumbers.map((e) => ({ key: '', value: e }));
    } else {
      this.bankAccountNumbers = [];
    }

    if (typeof params.am === 'string') {
      const amounts = params.am.split(',');
      this.amounts = amounts.map((e) => ({ key: '', value: e }));
    } else {
      this.amounts = [];
    }

    if (typeof params.desc === 'string') {
      const disbursementDescriptions = params.desc.split(',');
      this.disbursementDescriptions = disbursementDescriptions.map((e) => ({ key: '', value: e }));
    } else {
      this.disbursementDescriptions = [];
    }

    if (typeof params.nt === 'string') {
      const note = params.nt;
      this.disbursementNote = note;
    } else {
      this.disbursementNote = '';
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getDisbursment(false, page);
  }

  search() {
    const dr = this.dateRequest.startDate === null || this.dateRequest.endDate === null ? undefined : {
      start: dayjs(this.dateRequest.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.dateRequest.endDate).format('YYYY-MM-DD'),
    };

    const dd = this.dateDisburse.startDate === null || this.dateDisburse.endDate === null ? undefined : {
      start: dayjs(this.dateDisburse.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.dateDisburse.endDate).format('YYYY-MM-DD'),
    };

    this.$router.push({
      query: {
        dr: dr && `${dr.start},${dr.end}`,
        dd: dd && `${dd.start},${dd.end}`,
        ba: this.banks.length === 0 ? undefined : this.banks.map((e) => `${e.label}_${e.value}`).join(','),
        na: this.names.length === 0 ? undefined : this.names.map((e) => e.value).join(','),
        re: this.referenceIds.length === 0 ? undefined : this.referenceIds.map((e) => e.value).join(','),
        em: this.emails.length === 0 ? undefined : this.emails.map((e) => e.value).join(','),
        bn: this.bankAccountNames.length === 0 ? undefined : this.bankAccountNames.map((e) => e.value).join(','),
        bu: this.bankAccountNumbers.length === 0 ? undefined : this.bankAccountNumbers.map((e) => e.value).join(','),
        am: this.amounts.length === 0 ? undefined : this.amounts.map((e) => e.value).join(','),
        // eslint-disable-next-line max-len
        desc: this.disbursementDescriptions.length === 0 ? undefined : this.disbursementDescriptions.map((e) => e.value).join(','),
        nt: this.disbursementNote,
      },
    });
  }

  async exportData() {
    this.loadingExport = true;
    await this.getDisbursment(true, 1);
    this.loadingExport = false;
  }

  cancel() {
    this.dateRequest = {
      startDate: null,
      endDate: null,
    };
    this.dateDisburse = {
      startDate: null,
      endDate: null,
    };
    this.banks = [];
    this.referenceIds = [];
    this.names = [];
    this.emails = [];
    this.bankAccountNames = [];
    this.bankAccountNumbers = [];
    this.amounts = [];
    this.disbursementDescriptions = [];
    this.disbursementNote = '';

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  showPreview() {
    this.$refs.report.showPreview();
  }

  selectChange(count: number) {
    this.selectedCount = count;
  }
}
